import { useCallback, useEffect } from 'react';
import { useDataChannel } from '@livekit/components-react';
import type { ReceivedDataMessage } from '@livekit/components-core';
import { useStudyModeStore } from '@/stores/studyMode.ts';
import { EVENTS } from '@/consts/events.ts';

function StudyModeManager() {
  const isPracticeMode = useStudyModeStore((state) => state.isPracticeMode);
  const { setIsPracticeMode, setSend } = useStudyModeStore.getState();

  const onMessage = useCallback(
    (msg: ReceivedDataMessage) => {
      const { isPracticeMode: newMode } = JSON.parse(new TextDecoder().decode(msg.payload));
      if (typeof newMode === 'boolean') {
        setIsPracticeMode(newMode);
      }
    },
    [setIsPracticeMode]
  );

  const { send } = useDataChannel(EVENTS.CHANGE_STUDY_MODE, onMessage);

  useEffect(() => {
    setSend(send);
    return () => setSend(null);
  }, [send, setSend]);

  useEffect(() => {
    document.documentElement.style.setProperty(
      '--primary-color',
      isPracticeMode ? '#10b981' : '#0ea5e9'
    );
    document.documentElement.style.setProperty(
      '--primary-color-hover',
      isPracticeMode ? '#019e6aff' : '#0284c7'
    );
  }, [isPracticeMode]);

  // reset practice mode on Meeting component unmount
  useEffect(() => {
    return () => {
      setIsPracticeMode(false);
      document.documentElement.style.setProperty('--primary-color', '#0ea5e9');
      document.documentElement.style.setProperty('--primary-color-hover', '#0284c7');
    };
  }, []);

  return null;
}

export default StudyModeManager;
